module.exports = __webpack_public_path__ + "static/media/128x128.5fd207e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/128x128.jpg
// module id = 18
// module chunks = 1